import axios from 'axios';

const API_URL = 'https://dailyreportsapi.winggs.in/api/users';
// const API_URL = 'http://localhost:5000/api/users'; // Use this for local development

const userService = {
  // Get all users (admin only)
  getAllUsers: async () => {
    const response = await axios.get(`${API_URL}`);
    return response.data;
  },

  // Get all developers (admin only)
  getAllDevelopers: async () => {
    const response = await axios.get(`${API_URL}/developers`);
    return response.data;
  },
  
  // Get users by role (admin only)
  getUsersByRole: async (role) => {
    const response = await axios.get(`${API_URL}/role/${role}`);
    return response.data;
  },

  // Get user by ID (admin only)
  getUserById: async (id) => {
    const response = await axios.get(`${API_URL}/${id}`);
    return response.data;
  },
  
  // Update user details (admin only)
  updateUser: async (id, userData) => {
    const response = await axios.put(`${API_URL}/${id}`, userData);
    return response.data;
  },
  
  // Update user password (admin only)
  updatePassword: async (id, password) => {
    const response = await axios.put(`${API_URL}/${id}/password`, { password });
    return response.data;
  },
  
  // Delete user (admin only)
  deleteUser: async (id) => {
    const response = await axios.delete(`${API_URL}/${id}`);
    return response.data;
  }
};

export default userService;
